import {initWebComponent} from "@/helpers/web-component-helper";
import {getTree} from "@/http/services/http-services-tree";
import {updateLanguage} from "@/modules/language/language";
import {initMutationLayers} from "@/helpers/tools/tools-mutation-helper";
import {initUserSessions} from "@/helpers/user-session-helper";
import {getAllBySelector, getBySelector, removeElementBySelector} from "@/helpers/element-helper";
import {addLayer} from "@/helpers/ol/ol-layer-helper";
import {addLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {initLayerMenuGroupItemClicks} from "@/helpers/layer-menu-helper";
import {setLayerByViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";
import {initContextMenu} from "@/helpers/context-menu-helper";

const template = document.createElement('template');

export class LayerMenuOverviewComponent extends HTMLElement{
    constructor(){
        super();

        let html = ''
        getTree().then((tree) => {

            removeElementBySelector('#fillCatalog')

            window.menuGroups = []
            window.branch = []
            window.branchMerged = []
            window.branch[0] = []
            window.branchChild = []
            window.totalLayers = 0
            tree[0].branch.map((branch, key) => {
                // window.branch[key] = branch
                if (branch.folder) {

                    window.menuGroups.push(branch)

                    window.branch[0][key] = branch
                    html += `<layer-menu-group data-id="${branch.ID}" data-label="${branch.label}" data-depth="0" data-key="` + key + `"></layer-menu-group>`
                } else {
                    window.branch[0][key] = branch
                    window.totalLayers++
                    html += `<layer-menu-group-item data-key="` + key + `" data-id="` + branch.ID +  `"  data-checkbox="` + branch.checkbox +  `" data-depth="0" data-root="true" data-checked="` + branch.checked + `" data-label="` + branch.label + `"></layer-menu-group-item>`
                }
            })

            window.tree = tree

            template.innerHTML = html;

            initWebComponent(this, template)

            getBySelector('#spnTotalLayers').innerHTML = window.totalLayers

            updateLanguage()

            initMutationLayers()

            initUserSessions()

            initLayerMenuGroupItemClicks(this)

            setLayerByViewResolution(window.map.getView().getResolution())

            initContextMenu()

            if(window.urlParamsObject.aan) {
                window.urlParamsObject.aan.split(',').map((presentationName) => {
                    const element = document.querySelector(`layer-menu-group-merged[data-label="${presentationName}"]`)
                    if (element) {
                        if (!element.querySelector('input').checked) {
                            element.querySelector('input').click()
                        }
                    }
                })
            }
        }).catch(() => {
            if(!window.isAdfs) {
                location.href = window.kaartViewerUrl + '/admin/login?redirect=../' + window.location.search + '&v=5'
            }
        })
    }
}
